import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { computed, ref, watch } from 'vue';
import { getProductsWithSet } from '@/api/shopify/optionSets';
import { OptionSetDto } from '@extTypes/options/optionSet';
import { useStore } from '@/store';
import config from '@/config/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionSetLinkedToProductsModal',
  props: {
    show: { type: Boolean },
    optionSet: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    show: boolean;
    optionSet?: OptionSetDto;
};

const store = useStore();
const userStore = computed(() => store.state.store);
const baseUrl = config.CUSTOMILY_BASE_URL;





const products = ref<
    {
        title: string;
        id: string;
        isDesign: boolean;
        imgSrc?: string;
        active: boolean;
        published: boolean;
    }[]
>([]);

const loading = ref(false);

watch(
    () => props.optionSet?.id,
    async (newId) => {
        if (!newId) return;
        loading.value = true;
        try {
            const data = await getProductsWithSet(newId);
            products.value = data;
        } catch (error) {
            console.error('Error retrieving products with sets:', error);
        } finally {
            loading.value = false;
        }
    },
    { immediate: true }
);

const isPublished = (product: (typeof products.value)[number]) => {
    return product.published === true;
};

const isActive = (product: (typeof products.value)[number]) => {
    return product.imgSrc?.includes('woo.customily') || product.imgSrc?.includes('etsystatic.com')
        ? product.active === true
        : false;
};

const getStatusLabel = (product: (typeof products.value)[number]) => {
    if (isPublished(product)) return 'Published';
    if (isActive(product)) return 'Active';
    return 'Draft';
};

return { __sfc: true,store, userStore, baseUrl, props, emit, products, loading, isPublished, isActive, getStatusLabel, BModal }
}

})